<template>
  <el-dialog
    title="业绩金额分段"
    :visible.sync="visible"
    width="300px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="form"
      label-width="90px">
      <el-form-item
        label="分段值:"
        prop="splitNum">
        <el-input-number
          v-model="form.splitNum"
          :min="min"
          :step="1000"
          :max="max"></el-input-number>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GiftsCardModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      max: 1,
      min: 0,
      index: -1,
      type: 'add',
      form: {
        splitNum: 0
      },
      rules: {
        splitNum: [
          { required: true, message: '请上传卡片', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.callback && this.callback(this.form.splitNum, this.type, this.index)
          this.toggleModal(false)
        }
      })
    },
    init({ min, max, index, value }, type) {
      this.min = min
      this.max = max
      this.index = index
      this.type = type
      this.form.splitNum = value
      this.toggleModal(true)
    }
  }
}
</script>
